var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRoundedRightArrow = function SvgRoundedRightArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 45
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 43",
    d: "M25.795 13.755a1.592 1.592 0 0 0-2.329 2.17l4.644 4.988H13.238a1.588 1.588 0 0 0 0 3.176H28.11l-4.644 4.988a1.6 1.6 0 0 0 .079 2.249 1.54 1.54 0 0 0 1.085.423 1.616 1.616 0 0 0 1.164-.5l7.132-7.661a1.593 1.593 0 0 0 0-2.17Z",
    fill: "#2a4d4f"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 44",
    d: "M22.5 0A22.5 22.5 0 1 0 45 22.5 22.532 22.532 0 0 0 22.5 0Zm0 41.86A19.36 19.36 0 1 1 41.86 22.5 19.383 19.383 0 0 1 22.5 41.86Z",
    fill: "#2a4d4f"
  })));
};
export default SvgRoundedRightArrow;